module.exports = __webpack_public_path__ + "img/DSC_1972.e2784cb8.JPG";